export default __webpack_public_path__ + "static/media/granville09.ff35a975.jpg";